import { i18n } from "../config/i18n";
import { BAHRAIN_COUNTRY_CODE } from "../constants/countries";
import { CountryCode } from "../types/country-types";
import { getLocalisedNumber } from "./translations";
import { FormatMoneyType } from "../types/general";
import { Locale } from "../types/translations";

const precisionForCountryCode = (countryCode?: CountryCode) =>
  countryCode === BAHRAIN_COUNTRY_CODE ? 3 : 2;

const formatMoney = (
  currency: number,
  hideCurrency: boolean,
  locale: Locale,
  countryCode?: CountryCode,
): FormatMoneyType => {
  const amount = i18n.numberToCurrency(convertMoney(currency, countryCode), {
    unit: "",
    precision: precisionForCountryCode(countryCode),
  });
  const localisedAmount = getLocalisedNumber(amount, locale);
  if (hideCurrency) {
    return { amount: localisedAmount, currencySymbol: "" };
  }

  const currencySymbols: Record<string, string> = {
    BH: i18n.t("bahrainCurrency", {
      locale,
    }),
    AE: i18n.t("uaeCurrency", {
      locale,
    }),
    SA: "﷼",
  };

  return {
    amount: localisedAmount,
    currencySymbol: currencySymbols[countryCode || "SA"] || "",
  };
};

const convertMoney = (currency?: number, countryCode?: CountryCode): number => {
  if (!currency) {
    return 0;
  }

  if (currency < 100) {
    return currency / 100;
  }
  const currencyStr = currency.toString();
  const currencyStrLen = currencyStr.length;
  const precision = precisionForCountryCode(countryCode);

  return Number(
    `${currencyStr.substring(
      0,
      currencyStrLen - precision,
    )}.${currencyStr.substring(currencyStrLen - precision, currencyStrLen)}`,
  );
};

export { convertMoney, formatMoney };
